import { LANG_LABELS, LOCALES, useLang } from '../LangContext';

/* Dil geçiş düğmesi — üç dil arasında sırayla döner (TR → EN → DE → TR)
   Ya da genişletilmiş modda tüm diller ayrı buton olarak gösterilir */
export default function LanguageToggle({ className = '', expanded = false }) {
  const { lang, setLang, cycleLang } = useLang();

  if (expanded) {
    return (
      <div className={`lang-toggle-group ${className}`.trim()} role="radiogroup" aria-label="Dil seçimi">
        {Object.keys(LOCALES).map((code) => (
          <button
            key={code}
            type="button"
            role="radio"
            aria-checked={lang === code}
            className={`lang-toggle-btn${lang === code ? ' is-active' : ''}`}
            onClick={() => setLang(code)}
          >
            {LANG_LABELS[code]}
          </button>
        ))}
      </div>
    );
  }

  return (
    <button
      type="button"
      className={`lang-toggle ${className}`.trim()}
      onClick={cycleLang}
      title={`Dil: ${LANG_LABELS[lang]}`}
      aria-label="Dili değiştir"
    >
      {LANG_LABELS[lang]}
    </button>
  );
}
